module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/saicopvp.00040991.png";